import { render, staticRenderFns } from "./locationList.vue?vue&type=template&id=57631a5b&scoped=true&"
import script from "./locationList.vue?vue&type=script&lang=js&"
export * from "./locationList.vue?vue&type=script&lang=js&"
import style0 from "./locationList.vue?vue&type=style&index=0&id=57631a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57631a5b",
  null
  
)

export default component.exports